<template>
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 8 8"
    style="enable-background: new 0 0 8 8;"
    xml:space="preserve"
  >
    <slot />
    <line :stroke="color" class="st0" x1="7.5" y1="0.5" x2="0.5" y2="7.5" />
    <line :stroke="color" class="st0" x1="0.5" y1="0.5" x2="7.5" y2="7.5" />
  </svg>
</template>

<script>
export default {
  props: {
    color: String,
  },
};
</script>
